import { useAppDispatch } from 'src/store/hooks';
import { handleModalLogin } from 'src/store/actions/modal';
import Image from '../reusable/Image';
import { H5, Paragraph } from '../reusable/Typography';
import * as SVG from 'src/assets/icons';
import { Button } from 'src/components/reusable/Buttons';

const AccountVerifiedPage = () => {
  const dispatch = useAppDispatch();

  return (
    <div className="relative h-[calc(100vh-1600px)] container mx-auto flex justify-center">
      <div className="absolute top-1/2 transform translate-y-1/2 max-w-md">
        <div className="flex justify-center mb-10">
          <Image className="w-40 h-40" src={SVG.GreenCheckGiftCard} />
        </div>
        <div className="text-center">
          <H5 className="font-medium mb-2">Account Verified</H5>
          <Paragraph>Your account has been verified successfully.</Paragraph>
          <Paragraph>Click the button below to buy gift card </Paragraph>
        </div>
        <div>
          <Button
            onClick={() => dispatch(handleModalLogin(true))}
            className="w-[450px] mt-10 text-sm"
          >
            Send gift card
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AccountVerifiedPage;
